/**
 * English - `tipsReviews`: the ⓘ explanations beside the product review
 * moderation fields. One key per field, `<form>.<field>`, passed as the
 * field's `info`. Conventions: see `common.ts`.
 */
const tipsReviews: Record<string, string> = {
  'settings.auto_publish':
    'Turn this on to show new reviews on your store as soon as customers post them. Leave it off to check each review first: new and edited reviews then wait in the Pending tab until you approve them.',
  'reply.reply':
    'Your answer to this review. It is public and shows under the review on the product page, so keep it polite and helpful. Up to 1000 characters. Example: Thank you for the kind words - see you again soon!',
};

export default tipsReviews;
